import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * Auth is carried by the `access_token` httpOnly cookie the backend sets on
 * /auth/verify-code and /auth/pin-login. `withCredentials: true` makes the
 * browser attach that cookie to every /api/* request. No JS-readable token.
 */
const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export default api;
